<template lang="html">
  <div class="add-page">
    <Overlay
      width="x-small"
      :autoHeight="true"
      :link="{name: 'pages'}">

      <add-page-form
        v-model="sitePage"
        @submit="submitPage"
        :errors="errors">
      </add-page-form>
    </Overlay>
  </div>
</template>

<script>
import page from '@/mixins/page'
import {createCompanySitePageData} from '@/lib/pages'

import AddPageForm from '@/components/forms/AddPageForm'
import Overlay from '@/components/Overlay'

export default {
  name: 'AddPage',

  components: {
    AddPageForm,
    Overlay
  },

  mixins: [page],

  props: {
    siteId: String,
    companyId: String,
    totalPages: Number
  },

  data() {
    return {
      sitePage: {},
      errors: {},
      title: 'Add Page'
    }
  },

  methods: {
    submitPage() {
      createCompanySitePageData(this.companyId, this.siteId, this.sitePage)
        .then((page) => {
          this.$router.push({
            name: 'add-list',
            params: {
              companyId: this.companyId,
              siteId: this.siteId,
              pageId: page.data.id
            }
          })

          this.$emit('updatePage', this.createdNotification)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    }
  },

  computed: {
    createdNotification() {
      return {
        type: 'success',
        content: `Page ${this.sitePage.name} created!`
      }
    }
  }
}
</script>

<style lang="sass">
.add-page
</style>
